import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';
import type { PatternDto, UpdatePatternDto } from '../types';

export const useUpdatePattern = (projectUuid: string) => {
  const queryClient = useQueryClient();

  return useMutation<PatternDto, Error, { uuid: string; data: UpdatePatternDto }>({
    mutationFn: ({ uuid, data }) =>
      apiClient.patch(`/v1/projects/${projectUuid}/patterns/${uuid}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['patterns', projectUuid] });
    },
  });
};
